export function downloadBinary({ filename, content_type = 'application/zip', data }) {
  const blob = new Blob([data], { type: content_type });
  const url = window.URL.createObjectURL(blob);

  // Create temporary link and trigger download
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
